import React, {useContext, useEffect, useState} from "react";
import {Menu, type MenuProps, theme} from "antd";
import Sider from "antd/es/layout/Sider";
import {useNavigate} from "react-router-dom";
import {RiBrainLine, RiHome2Fill, RiInfinityFill, RiSettingsFill} from "react-icons/ri";
import {AuthContext} from "../../../config/AuthContext";
import {FaGraduationCap} from "react-icons/fa";
import {GoProjectSymlink} from "react-icons/go";
import {IoHomeOutline} from "react-icons/io5";
import {PiGraduationCapThin} from "react-icons/pi";

interface Props {
    currentVal: number,
    setPantalla: (value: number) => void;
}

const AppSider = (props: Props) => {
    const [pantalla, setPantalla] = useState(props.currentVal);
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);

    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Web Dubtes';
    }, []);

    const titles: string[] = ['Home', 'Projectes', 'Notes'];
    const paths: string[] = ['/abp', '/abp/projectes', '/abp/avaluacions'];
    const titlesRoot: string[] = ['Configuracions', 'Notes'];
    const pathsRoot: string[] = ['/configuracio', '/abp/avaluacions'];

    const items2: MenuProps['items'] = [IoHomeOutline, GoProjectSymlink, PiGraduationCapThin].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titles[index],
                onClick: () => navigate(paths[index])
            };
        },
    );

    const itemsRoot: MenuProps['items'] = [IoHomeOutline].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titlesRoot[index],
                onClick: () => navigate(pathsRoot[index])
            };
        },
    );

    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();

    return (
        <Sider style={{background: colorBgContainer}} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + ""]}
                defaultOpenKeys={['sub1']}
                style={{height: '100%'}}
                items={user.tipus === "0" ? itemsRoot : items2}
            />
        </Sider>
    );
}


export default AppSider;